export const ModelObjectTypeEnum = Object.freeze({
    object: "Object",
    polygon: "Polygon"
})